export const ROUTES = {
    HOME: '/',
    GAME: '/play',
    STATS: '/stats'
}
